/* Klaviyo's back-in-stock "Notify Me" trigger lags one variant switch
   behind the real stock status (investigated at length — see
   PROGRESS.md). A first attempt at nudging Klaviyo's own detection
   with an extra DOM mutation on `on:variant:change` fixed the SHOW
   direction but broke the HIDE direction (got permanently stuck
   visible) — that attempt was reverted. Its own click/modal behavior
   was always confirmed working fine; only the show/hide timing was
   ever wrong, on both directions in the original, unmodified bug.

   This version doesn't try to influence Klaviyo's own detection logic
   at all — it directly enforces the anchor's visibility from this
   project's own reliable data (`evt.detail.variant.available`, from
   variant-picker.js's own already-correct variant object) every time
   the variant changes, and keeps re-asserting that correct state for
   a few seconds afterward in case Klaviyo's own script tries to
   override it in the meantime (its exact internal timing is unknown
   and unreliable — see PROGRESS.md). The anchor itself is never
   replaced or reinitialized, so Klaviyo's own click handler/modal
   logic (attached once at page load) keeps working regardless of who
   last touched its inline style. */
(function () {
  var enforceUntil = 0;
  var enforceTimer = null;
  /* Real bug found: this used to be a plain function-scoped `var
     available` inside the event listener, captured by reference in
     the setInterval closure created on the FIRST call. If a second
     on:variant:change fired while that interval was still running
     (within the same 3-second window — e.g. selecting a variant on a
     page that loaded without ?variant= in the URL triggers more than
     one change event in quick succession), the new call applied its
     own correct value once, but the FIRST call's interval — still
     alive, still holding its own OLD `available` in its closure —
     kept firing every 150ms and stomping the correct value back to
     the stale one. That's exactly what read as "shows for a split
     second, then disappears" (or the reverse). Moving the desired
     state to this shared, outer variable means the single running
     interval always re-applies whatever the LATEST event said,
     regardless of which invocation actually started the timer. */
  var currentAvailable = null;

  /* Real bug found: llm-product-gallery-v2.css forces this trigger
     visible with `.llm-klaviyo-bis-trigger:not([style*="display:
     none"]) { display: flex !important; }` — written to respect
     Klaviyo's OWN native hide/show convention (its onsite.js sets the
     literal inline string `style="display: none;"`, WITH a space
     after the colon, and clears it to `style=""` when showing).
     Setting `anchor.style.display = 'none'` here (a property
     assignment, not a literal string) serializes to `display:none;`
     — NO space — in this browser, so the CSS selector's `:not()`
     substring match never found it and forced the button visible
     regardless of what this script set, on every product where
     Klaviyo doesn't independently re-hide it. Using cssText instead
     writes the exact literal string the CSS selector is matching
     against. */
  function applyCorrectVisibility(available) {
    var anchor = document.querySelector('.klaviyo-bis-trigger');
    if (!anchor) return;
    if (available) {
      anchor.style.cssText = 'display: none;';
    } else {
      anchor.style.cssText = '';
    }
  }

  document.addEventListener('on:variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    currentAvailable = !!variant.available;

    applyCorrectVisibility(currentAvailable);
    enforceUntil = Date.now() + 3000;

    if (!enforceTimer) {
      enforceTimer = setInterval(function () {
        if (Date.now() > enforceUntil) {
          clearInterval(enforceTimer);
          enforceTimer = null;
          return;
        }
        applyCorrectVisibility(currentAvailable);
      }, 150);
    }
  });

  /* INITIAL LOAD: the theme does NOT fire on:variant:change on page load, so on a direct load of a
     sold-out variant the trigger stayed hidden (its inline display:none was never cleared) — only a
     variant SWITCH revealed it. Determine the selected variant's availability straight from the
     server-rendered Add-to-Cart button (disabled + a "Sold out" label — not the "make a selection"
     preselection label — means out of stock; the theme keeps that button in sync per variant) and
     apply the correct visibility on load. The change handler above then takes over. */
  function initialCheck() {
    var atc = document.querySelector('.js-product-form-main [name="add"]')
      || document.querySelector('product-form [name="add"]');
    if (!atc) return;
    var txt = (atc.textContent || '').trim();
    var preselect = atc.getAttribute('data-preselection-text');
    var soldOut = atc.disabled && txt !== '' && txt !== preselect;
    currentAvailable = !soldOut;
    applyCorrectVisibility(currentAvailable);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialCheck);
  } else {
    initialCheck();
  }
  // Re-check after the buy button's own on-load variant re-render settles.
  setTimeout(initialCheck, 1000);
})();
